export default __webpack_public_path__ + "static/inst_1-ffd3c628bd8fe8b8060b4783b4893d8a.jpg";